
  var sku_values_l = ''; //Valor de todas las combinaciones colocadas en el ojo izquierdo
  var sku_values_r = ''; //Valor de todas las combinaciones colocadas en el ojo derecho
  var var_l_sph = ''; //Este es el valor del SPH en el ojo izquierdo
  var var_r_sph = ''; //Este es el valor del SPH en el ojo derecho

  $('#right-upc input, #left-upc input').val(val_upc);
	
$('#left-graduacion').click(function() {
    var_l_sph = $('#4055360241742_option_4').val();
	console.log(var_l_sph); 
	unify_values_l();
	fetch_sku_l();
});


$('#right-graduacion').click(function() {
    var_r_sph = $('#4055360241742_option_5').val();
	console.log(var_r_sph); 
	unify_values_r();
	fetch_sku_r();
});


function unify_values_l(){
	sku_values_l = var_l_sph ;
	console.log(sku_values_l);
}

function unify_values_r(){
	sku_values_r = var_r_sph;
	console.log(sku_values_r);
}

function fetch_sku_l(){
 	switch (sku_values_l) { 
case '+0.50' : $('#left-sku input').val('562334'); break;
case '+0.75' : $('#left-sku input').val('562341'); break;
case '+1.00' : $('#left-sku input').val('562358'); break;
case '+1.25' : $('#left-sku input').val('562365'); break;
case '+1.50' : $('#left-sku input').val('562372'); break;
case '+1.75' : $('#left-sku input').val('562389'); break;
case '+2.00' : $('#left-sku input').val('562396'); break;
case '+2.25' : $('#left-sku input').val('562402'); break;
case '+2.50' : $('#left-sku input').val('562419'); break;
case '+2.75' : $('#left-sku input').val('562426'); break;
case '+3.00' : $('#left-sku input').val('562433'); break;
case '+3.25' : $('#left-sku input').val('562440'); break;
case '+3.50' : $('#left-sku input').val('562457'); break;
case '+3.75' : $('#left-sku input').val('562464'); break;
case '+4.00' : $('#left-sku input').val('562471'); break;
case '+4.25' : $('#left-sku input').val('562488'); break;
case '+4.50' : $('#left-sku input').val('562495'); break;
case '+4.75' : $('#left-sku input').val('562501'); break;
case '+5.00' : $('#left-sku input').val('562518'); break;
case '+5.25' : $('#left-sku input').val('562525'); break;
case '+5.50' : $('#left-sku input').val('562532'); break;
case '+5.75' : $('#left-sku input').val('562549'); break;
case '+6.00' : $('#left-sku input').val('562556'); break;
case '+6.50' : $('#left-sku input').val('562563'); break;
case '+7.00' : $('#left-sku input').val('562570'); break;
case '+7.50' : $('#left-sku input').val('562587'); break;
case '+8.00' : $('#left-sku input').val('562594'); break;
case '-0.50' : $('#left-sku input').val('562600'); break;
case '-0.75' : $('#left-sku input').val('562617'); break;
case '-1.00' : $('#left-sku input').val('562624'); break;
case '-1.25' : $('#left-sku input').val('562631'); break;
case '-1.50' : $('#left-sku input').val('562648'); break;
case '-1.75' : $('#left-sku input').val('562655'); break;
case '-10.00' : $('#left-sku input').val('562662'); break;
case '-10.50' : $('#left-sku input').val('562679'); break;
case '-11.00' : $('#left-sku input').val('562686'); break;
case '-11.50' : $('#left-sku input').val('562693'); break;
case '-12.00' : $('#left-sku input').val('562709'); break;
case '-2.00' : $('#left-sku input').val('562716'); break;
case '-2.25' : $('#left-sku input').val('562723'); break;
case '-2.50' : $('#left-sku input').val('562730'); break;
case '-2.75' : $('#left-sku input').val('562747'); break;
case '-3.00' : $('#left-sku input').val('562754'); break;
case '-3.25' : $('#left-sku input').val('562761'); break;
case '-3.50' : $('#left-sku input').val('562778'); break;
case '-3.75' : $('#left-sku input').val('562785'); break;
case '-4.00' : $('#left-sku input').val('562792'); break;
case '-4.25' : $('#left-sku input').val('562808'); break;
case '-4.50' : $('#left-sku input').val('562815'); break;
case '-4.75' : $('#left-sku input').val('562822'); break;
case '-5.00' : $('#left-sku input').val('562839'); break;
case '-5.25' : $('#left-sku input').val('562846'); break;
case '-5.50' : $('#left-sku input').val('562853'); break;
case '-5.75' : $('#left-sku input').val('562860'); break;
case '-6.00' : $('#left-sku input').val('562877'); break;
case '-6.50' : $('#left-sku input').val('562884'); break;
case '-7.00' : $('#left-sku input').val('562891'); break;
case '-7.50' : $('#left-sku input').val('562907'); break;
case '-8.00' : $('#left-sku input').val('562914'); break;
case '-8.50' : $('#left-sku input').val('562921'); break;
case '-9.00' : $('#left-sku input').val('562938'); break;
case '-9.50' : $('#left-sku input').val('562945'); break;


 	    default:
        $('#left-sku input').val('SKU Desconocido');
    }
}//fetch_sku()

function fetch_sku_r(){
 	switch (sku_values_r) {
case '+0.50' : $('#right-sku input').val('562334'); break;
case '+0.75' : $('#right-sku input').val('562341'); break;
case '+1.00' : $('#right-sku input').val('562358'); break;
case '+1.25' : $('#right-sku input').val('562365'); break;
case '+1.50' : $('#right-sku input').val('562372'); break;
case '+1.75' : $('#right-sku input').val('562389'); break;
case '+2.00' : $('#right-sku input').val('562396'); break;
case '+2.25' : $('#right-sku input').val('562402'); break;
case '+2.50' : $('#right-sku input').val('562419'); break;
case '+2.75' : $('#right-sku input').val('562426'); break;
case '+3.00' : $('#right-sku input').val('562433'); break;
case '+3.25' : $('#right-sku input').val('562440'); break;
case '+3.50' : $('#right-sku input').val('562457'); break;
case '+3.75' : $('#right-sku input').val('562464'); break;
case '+4.00' : $('#right-sku input').val('562471'); break;
case '+4.25' : $('#right-sku input').val('562488'); break;
case '+4.50' : $('#right-sku input').val('562495'); break;
case '+4.75' : $('#right-sku input').val('562501'); break;
case '+5.00' : $('#right-sku input').val('562518'); break;
case '+5.25' : $('#right-sku input').val('562525'); break;
case '+5.50' : $('#right-sku input').val('562532'); break;
case '+5.75' : $('#right-sku input').val('562549'); break;
case '+6.00' : $('#right-sku input').val('562556'); break;
case '+6.50' : $('#right-sku input').val('562563'); break;
case '+7.00' : $('#right-sku input').val('562570'); break;
case '+7.50' : $('#right-sku input').val('562587'); break;
case '+8.00' : $('#right-sku input').val('562594'); break;
case '-0.50' : $('#right-sku input').val('562600'); break;
case '-0.75' : $('#right-sku input').val('562617'); break;
case '-1.00' : $('#right-sku input').val('562624'); break;
case '-1.25' : $('#right-sku input').val('562631'); break;
case '-1.50' : $('#right-sku input').val('562648'); break;
case '-1.75' : $('#right-sku input').val('562655'); break;
case '-10.00' : $('#right-sku input').val('562662'); break;
case '-10.50' : $('#right-sku input').val('562679'); break;
case '-11.00' : $('#right-sku input').val('562686'); break;
case '-11.50' : $('#right-sku input').val('562693'); break;
case '-12.00' : $('#right-sku input').val('562709'); break;
case '-2.00' : $('#right-sku input').val('562716'); break;
case '-2.25' : $('#right-sku input').val('562723'); break;
case '-2.50' : $('#right-sku input').val('562730'); break;
case '-2.75' : $('#right-sku input').val('562747'); break;
case '-3.00' : $('#right-sku input').val('562754'); break;
case '-3.25' : $('#right-sku input').val('562761'); break;
case '-3.50' : $('#right-sku input').val('562778'); break;
case '-3.75' : $('#right-sku input').val('562785'); break;
case '-4.00' : $('#right-sku input').val('562792'); break;
case '-4.25' : $('#right-sku input').val('562808'); break;
case '-4.50' : $('#right-sku input').val('562815'); break;
case '-4.75' : $('#right-sku input').val('562822'); break;
case '-5.00' : $('#right-sku input').val('562839'); break;
case '-5.25' : $('#right-sku input').val('562846'); break;
case '-5.50' : $('#right-sku input').val('562853'); break;
case '-5.75' : $('#right-sku input').val('562860'); break;
case '-6.00' : $('#right-sku input').val('562877'); break;
case '-6.50' : $('#right-sku input').val('562884'); break;
case '-7.00' : $('#right-sku input').val('562891'); break;
case '-7.50' : $('#right-sku input').val('562907'); break;
case '-8.00' : $('#right-sku input').val('562914'); break;
case '-8.50' : $('#right-sku input').val('562921'); break;
case '-9.00' : $('#right-sku input').val('562938'); break;
case '-9.50' : $('#right-sku input').val('562945'); break;


 		default:
        $('#right-sku input').val('SKU Desconocido');
    }
}//fetch_sku()
